import React, { Component } from 'react'
import { Button, } from "reactstrap";
import '../../assets/css/component/Button.css'

export default class AddButton extends Component {
  render() {
    return (
      <div>
        <Button type='button' variant="" className='add_btn ps-3 pe-3'>{this.props.name}</Button>
      </div>
    )
  }
}
